import { FC, PropsWithChildren, ReactNode } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';

const ChartPanelLayout: FC<PropsWithChildren<ChartPanelLayoutProps>> = ({
  header,
  children,
}) => {
  const { classes } = useStyles();
  return (
    <div className={classes.chartPanelLayout}>
      <div className={classes.header}>{header}</div>
      <div className={classes.main}>{children}</div>
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  chartPanelLayout: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  main: {
    flexGrow: 1,
  },
  header: {
    minHeight: '2rem',
  },
}));

export interface ChartPanelLayoutProps {
  header: ReactNode;
}

export default ChartPanelLayout;
